/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectGcpFolderRequest {
  /**
  * The organization ID.
  */
  'organizationId': string;
  /**
  * The folder ID to connect.
  */
  'folderId': string;
  /**
  * GCP Organization management service account ID.
  */
  'managementServiceAccountId': string;
  /**
  * Glob patterns for project IDs to exclude (e.g., internal-*, test-*)
  */
  'excludeProjectPatterns'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "organizationId",
      "baseName": "organizationId",
      "type": "string",
      "format": ""
    },
    {
      "name": "folderId",
      "baseName": "folderId",
      "type": "string",
      "format": ""
    },
    {
      "name": "managementServiceAccountId",
      "baseName": "managementServiceAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "excludeProjectPatterns",
      "baseName": "excludeProjectPatterns",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectGcpFolderRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

